import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import * as Composition from "./composition";
import { useHotelInfoUpdateMutation } from "../../repository/mutation/use-hotel-info-update-mutation";

import type { HotelSettingsHotelInfoFormModel } from "../../type";

type Props = {
	viewModel: HotelSettingsHotelInfoFormModel["ViewModel"];
	resetViewModel: () => void;
};

export const useUpdateHotelSettingsHotelInfoDefault = ({ viewModel, resetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onUpdate } = useHotelInfoUpdateMutation();
	/**
	 * @todo 副作用は UI で定義
	 */
	const onUpdateHotelSettingsHotelInfoDefault = useCallback(async () => {
		showLoadingScreenCallback();

		const input = Composition.Converter.viewModelToInputConverter({ viewModel });
		const { errors } = await onUpdate(input).finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "施設情報を更新しました",
			});
			resetViewModel();
		}
	}, [hideLoadingScreenCallback, onUpdate, resetViewModel, showLoadingScreenCallback, viewModel]);

	return {
		onUpdateHotelSettingsHotelInfoDefault,
	};
};
